import { render, staticRenderFns } from "./SignPropertySelector.vue?vue&type=template&id=e6b9c9bc&"
import script from "./SignPropertySelector.vue?vue&type=script&lang=ts&"
export * from "./SignPropertySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports